import {InjectionToken} from '@angular/core';
import {CompanyWeaveStructure} from '@domain/textile-data/company-weave-structure/company-weave-structure';
import {Observable} from 'rxjs';
import {Repository} from '../repository';

export const COMPANY_WEAVE_STRUCTURES = new InjectionToken<CompanyWeaveStructures>('CompanyWeaveStructures');

export interface CompanyWeaveStructures extends Repository<CompanyWeaveStructure, CompanyWeaveStructure> {
  saveCompanyWeaveStructure(item: CompanyWeaveStructure): Observable<void>;
  getByCompanyId(companyId: string): Observable<number[]>;
}
